/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var LogoMicrosoftIcon16Light = forwardRef('LogoMicrosoftIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 2.5A1.5 1.5 0 0 1 2.5 1h10A1.5 1.5 0 0 1 14 2.5v10a1.5 1.5 0 0 1-1.5 1.5h-10A1.5 1.5 0 0 1 1 12.5v-10ZM2 8v4.5a.5.5 0 0 0 .5.5H7V8H2Zm5-1H2V2.5a.5.5 0 0 1 .5-.5H7v5Zm1 1v5h4.5a.5.5 0 0 0 .5-.5V8H8Zm5-1H8V2h4.5a.5.5 0 0 1 .5.5V7Z" })));
});
